<section class="section">
  <textarea
    [ngModel]="noteText"
    (ngModelChange)="onTextChange($event)"
    [disabled]="!textEditable"
  ></textarea>
</section>
